import MDEditor from '@uiw/react-md-editor'
import React from 'react'

const TalentDescription = ({content}) => {
  return (
    <MDEditor.Markdown source={content} />
  )
}

export default TalentDescription